var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1171 18.0165C14.3838 18.2332 13.5171 18.3332 12.5005 18.3332H7.50046C6.48379 18.3332 5.61712 18.2332 4.88379 18.0165C5.06712 15.8498 7.29212 14.1415 10.0005 14.1415C12.7088 14.1415 14.9338 15.8498 15.1171 18.0165Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.66663H7.49984C3.33317 1.66663 1.6665 3.33329 1.6665 7.49996V12.5C1.6665 15.65 2.6165 17.375 4.88317 18.0166C5.0665 15.85 7.2915 14.1416 9.99984 14.1416C12.7082 14.1416 14.9332 15.85 15.1165 18.0166C17.3832 17.375 18.3332 15.65 18.3332 12.5V7.49996C18.3332 3.33329 16.6665 1.66663 12.4998 1.66663ZM9.99984 11.8083C8.34984 11.8083 7.0165 10.4666 7.0165 8.81664C7.0165 7.16664 8.34984 5.83329 9.99984 5.83329C11.6498 5.83329 12.9832 7.16664 12.9832 8.81664C12.9832 10.4666 11.6498 11.8083 9.99984 11.8083Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9833 8.81672C12.9833 10.4667 11.6499 11.8084 9.99994 11.8084C8.34994 11.8084 7.0166 10.4667 7.0166 8.81672C7.0166 7.16672 8.34994 5.83337 9.99994 5.83337C11.6499 5.83337 12.9833 7.16672 12.9833 8.81672Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.f13d24ae50b319e8dcbab037ca3cc9ce.svg";
export { ForwardRef as ReactComponent };